// extracted by mini-css-extract-plugin
export default {"canterbury":"Certificate_canterbury__o6rIK","zapfino":"Certificate_zapfino__frlK0","edwardian":"Certificate_edwardian__HEzng"};